import { Auth } from "../utils/auth";
import { HealthCheckApi } from "./HealthCheckApi";
import Router from "../router";
import axios from "./AxiosConfig";
import { RouterRounded } from "@mui/icons-material";

export class AssetApi {
    healthCheck = null;
    token = null;

    constructor() {
        let auth = new Auth();
        this.token = auth.getToken();
        this.healthCheck = new HealthCheckApi();
    }

    async list() {
        return await axios.get(`${Router.apiBaseUrl}${Router.apiAsset}/All`, {})
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        })
    }

    async create(data) {
        return await axios.post(Router.apiBaseUrl + Router.apiCreateAsset, data)
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        });
    }

    async downloadQR(assetIds, plantIds) {
        return await axios.post(
            Router.apiBaseUrl + Router.apiQRAsset,
            { ids: assetIds, plantIds: plantIds }, 
            { responseType: 'blob' }
        )
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        })
    }

    async getPlantManagementReport() {
        // TODO: Parametrizar URL
        return await axios.get(Router.apiBaseUrl + '/api/workpermit/Map/PlantManagementReport', {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        }).then(async response => {
            return await this.healthCheck.checkApi(response);
        }).catch(async error => {
            return await this.healthCheck.checkApi(error);
        })
    }

    async getPlantManagementCompany() {
        // TODO: Ajustar URL
        return await axios.get(Router.apiBaseUrl + '/api/workpermit/Map/PlantManagementCompany', {
            headers: {
                'Authorization': `Bearer ${this.token}`
            }
        }).then(async response => {
            return await this.healthCheck.checkApi(response);
        }).catch(async error => {
            return await this.healthCheck.checkApi(error);
        })
    }

    async getData(params) {
        try {
            const response = await axios.post(
                Router.apiBaseUrl + '/api/workpermit/Map/GetData',
                {
                    managementIds: params.managementIds,
                    trunkIds: params.trunkIds,
                    plantIds: params.plantIds,
                    companyIds: params.companyIds,
                    contractIds: params.contractIds,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch (error) {
            return await this.healthCheck.checkApi(error);
        }
    }

    async getDetailData(plantId) {
        try {
            const response = await axios.get(
                Router.apiBaseUrl + '/api/workpermit/Map/GetDetailData/:id'.replace(':id', plantId),
                {
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await this.healthCheck.checkApi(response);
        }catch (error) {
            return await this.healthCheck.checkApi(error);
        }
    }
    

}